import PagedList from "models/accessors/pagedList";
import LoanApplication from "../../../models/loan/loanApplication";
import LoanDocument from "models/loanDocument/loanDocument";
import DocumentRequest from "models/documentData/DocumentRequest";
import CustomerAccountVerificationDocument from "models/account/customer/customerAccountVerificationDocument";

export const PAGED_LOAN_APPLICATIONS = 'GET_PAGED_LOAN_APPLICATIONS';
export const LOAN_APPLICATION_DETAILS = 'GET_LOAN_APPLICATION_DETAILS';
export const LOAN_ADD_DOCUMENT = 'LOAN_ADD_DOCUMENT';
export const LOAN_DELETE_DOCUMENT = 'LOAN_DELETE_DOCUMENT';
export const LOAN_OPENREQUESTS = 'LOAN_OPENREQUESTS';
export const ID_DOCUMENTS_UPLOADED = 'ID_DOCUMENTS_UPLOADED';

export interface LoanApplicationState {
  pagedLoanApplications: PagedList<LoanApplication>,
  loanApplicationDetails: LoanApplication,
  openDocumentRequests: DocumentRequest[]
}

interface GetSubmittedLoansAction {
  type: typeof PAGED_LOAN_APPLICATIONS;
  payload: {
    pagedLoanApplications: PagedList<LoanApplication>;
  }
}

interface GetSubmittedLoanDetailsAction {
  type: typeof LOAN_APPLICATION_DETAILS;
  payload: {
    loanApplicationDetails: LoanApplication;
  }
}

interface AddLoanDocumentAction {
  type: typeof LOAN_ADD_DOCUMENT;
  payload: {
    loanDocuments: LoanDocument[];
  }
}

interface DeleteLoanDocumentAction {
  type: typeof LOAN_DELETE_DOCUMENT;
  payload: {
    loanDocumentId: number;
  }
}

interface FindOpenDocumentRequestsAction {
  type: typeof LOAN_OPENREQUESTS;
  payload: {
    openDocumentRequests: DocumentRequest[];
  }
}

interface IdDocumentsUploaded {
  type: typeof ID_DOCUMENTS_UPLOADED;
  payload: {
    customerDocuments: CustomerAccountVerificationDocument;
  }
}

export type LoanApplicationActionTypes = 
    GetSubmittedLoansAction 
  | GetSubmittedLoanDetailsAction 
  | AddLoanDocumentAction
  | FindOpenDocumentRequestsAction
  | DeleteLoanDocumentAction
  | IdDocumentsUploaded;